import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "password-change-layout" }
const _hoisted_2 = { class: "password-change-main" }
const _hoisted_3 = { class: "password-change-card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "input-with-icon" }
const _hoisted_7 = ["type", "disabled"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "input-with-icon" }
const _hoisted_10 = ["type", "disabled"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "input-with-icon" }
const _hoisted_13 = ["type", "disabled"]
const _hoisted_14 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = { class: "modal-body" }
const _hoisted_21 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainHeader),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-header" }, [
          _createElementVNode("h2", null, "Changer le mot de passe")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { for: "currentPassword" }, "Mot de passe actuel", -1)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.showCurrentPassword ? 'text' : 'password',
                  class: "form-control",
                  id: "currentPassword",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event)),
                  required: "",
                  disabled: _ctx.isLoading
                }, null, 8, _hoisted_7), [
                  [_vModelDynamic, _ctx.currentPassword]
                ]),
                _createElementVNode("span", {
                  class: "password-toggle",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCurrentPassword = !_ctx.showCurrentPassword))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.showCurrentPassword ? 'far fa-eye-slash' : 'far fa-eye')
                  }, null, 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { for: "newPassword" }, "Nouveau mot de passe", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.showNewPassword ? 'text' : 'password',
                  class: "form-control",
                  id: "newPassword",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
                  required: "",
                  minlength: "8",
                  disabled: _ctx.isLoading
                }, null, 8, _hoisted_10), [
                  [_vModelDynamic, _ctx.newPassword]
                ]),
                _createElementVNode("span", {
                  class: "password-toggle",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showNewPassword = !_ctx.showNewPassword))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.showNewPassword ? 'far fa-eye-slash' : 'far fa-eye')
                  }, null, 2)
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("small", { class: "form-text text-muted" }, "Minimum 8 caractères", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "confirmPassword" }, "Confirmer le nouveau mot de passe", -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.showConfirmPassword ? 'text' : 'password',
                  class: "form-control",
                  id: "confirmPassword",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                  required: "",
                  minlength: "8",
                  disabled: _ctx.isLoading
                }, null, 8, _hoisted_13), [
                  [_vModelDynamic, _ctx.confirmPassword]
                ]),
                _createElementVNode("span", {
                  class: "password-toggle",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showConfirmPassword = !_ctx.showConfirmPassword))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.showConfirmPassword ? 'far fa-eye-slash' : 'far fa-eye')
                  }, null, 2)
                ])
              ]),
              (_ctx.passwordMismatch)
                ? (_openBlock(), _createElementBlock("small", _hoisted_14, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1),
                    _createTextVNode(" Les nouveaux mots de passe ne correspondent pas ")
                  ])))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary btn-block",
              disabled: _ctx.isLoading
            }, [
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Mettre à jour le mot de passe"))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, _cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                    _createTextVNode(" Traitement en cours... ")
                  ])))
            ], 8, _hoisted_15)
          ], 32)
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.modalTitle), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("p", null, _toDisplayString(_ctx.modalMessage), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_ctx.isSuccess)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.redirectToLogin && _ctx.redirectToLogin(...args)))
                  }, " Se reconnecter "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-primary",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, " OK "))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MainFooter, { class: "password-change-footer" })
  ]))
}